import { ContextualMenuItemType } from "@fluentui/react";
import { stringUtils } from "cayo.ui";

export const toContextualMenuItemType = (
  itemType: string | undefined
): ContextualMenuItemType | undefined => {
  if (itemType === undefined) {
    return undefined;
  }
  const key = stringUtils.makePascal(itemType) as keyof typeof ContextualMenuItemType;
  return ContextualMenuItemType[key];
};
